<template>
  <div>
    <div class="wrapper-payment">
      <h4>{{ $t('graphs.payment') }}</h4>
      <div v-for="(chart, index) in charts" :key="index" class="payments">
        <canvas :id="chart.id"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'PaymentGraph',
  // eslint-disable-next-line vue/require-prop-types
  props: ['period'],

  data() {
    return {
      title: this.$t('graphs.payment'),
      charts: [
        {
          id: 'money',
          type: 'doughnut',
          chart: [],
          options: [],
          labels: [],
          colors: [
            'rgb(239, 83, 80)',
            'rgb(41, 182, 246)',
            'rgb(153, 153, 153)',
            'rgb(255, 112, 67)',
            'rgb(149, 117, 205)',
          ],
        },
        {
          id: 'profit',
          type: 'doughnut',
          options: [],
          chart: [],
          labels: [],
          colors: [
            'rgb(149, 117, 205)',
            'rgb(239, 83, 80)',
            'rgb(41, 182, 246)',
            'rgb(153, 153, 153)',
            'rgb(255, 112, 67)',
          ],
        },
      ],
    }
  },

  mounted() {
    this.$watch('period', this.fetch, { deep: true, immediate: true })
  },

  methods: {
    fetch() {
      this.$uiBlocker(
        this.$http
          .get('charts/profitinfo', {
            params: {
              from: this.period.gte,
              to: this.period.lte,
              division_id: this.currentDivision.id,
            },
          })
          .then(({ data }) => {
            this.draw(data)
          }),
        this.$el,
      )
    },

    draw(data) {
      // this.$refs.chart
      this.charts.forEach(chart => {
        let ctx = document.getElementById(chart.id).getContext('2d')

        this.getOptions(chart, data)

        let graph = chart.chart

        if (Object.keys(graph).length !== 0) {
          graph.destroy()
        }

        graph = new Chart(ctx, {
          type: chart.type,
          barPercentage: 12,
          data: {
            labels: chart.labels,
            datasets: [
              {
                data: chart.options,
                backgroundColor: chart.colors,
                borderWidth: 2,
              },
            ],
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
          },
        })

        chart.chart = graph
      })
    },

    getOptions(chart, data) {
      chart.labels = Object.keys(data[chart.id])
      chart.options = Object.values(data[chart.id])
    },
  },
}
</script>
